/* Cart add-ons (WP6, parity pass 2026-10-11). Under the cart's free-shipping bar (drawer and cart page), a short row of
   small gifts with a one-tap Add: up to three of the cheapest visible gifts that are not in the cart yet. While the cart
   is under the free-shipping threshold, the first card is the cheapest gift that closes the gap and says so; the others
   are plain add-ons. The bar itself stays in store.js; this script only watches for it to be drawn. Data:
   snippets/gift-cart-data.liquid (visible gifts only, cheapest available variant each, written by tools/build_store.py),
   so a hidden or held product is never suggested. Nothing is pre-selected and nothing is added without a tap. No gift
   note field (owner decision 8.5). */
(function () {
  "use strict";
  var el = document.getElementById("gift-catalog"); if (!el) return;
  var CAT; try { CAT = JSON.parse(el.textContent); } catch (e) { return; }
  if (!CAT || !CAT.items || !CAT.items.length) return;
  var MAX = 3;
  var HANDLES = CAT.items.map(function (i) { return i.handle; });
  var money = function (c) { return "$" + (c / 100).toFixed(2); };
  var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };

  /* The row: the cheapest gift that closes the gap first (when there is a gap), then the cheapest other gifts, none of
     them already in the cart; a gift in the cart is used only when nothing else is left. */
  function pick(gapC, inCart) {
    var fresh = CAT.items.filter(function (i) { return inCart.indexOf(i.handle) < 0; }).sort(function (a, b) { return a.price - b.price; });
    var out = [];
    if (gapC > 0) { var closer = fresh.filter(function (i) { return i.price >= gapC; })[0]; if (closer) { closer = Object.assign({}, closer, { gap: true }); out.push(closer); fresh = fresh.filter(function (i) { return i.handle !== closer.handle; }); } }
    while (out.length < MAX && fresh.length) out.push(fresh.shift());
    if (!out.length) { var any = CAT.items.filter(function (i) { return i.price >= gapC; }).sort(function (a, b) { return a.price - b.price; })[0]; if (any) out.push(any); }
    return out;
  }

  function card(it) {
    var opt = it.option ? esc(it.option) + ", " : "";
    return '<div class="gap-card' + (it.gap ? " gap-closes" : "") + '" data-gap-card data-handle="' + esc(it.handle) + '">' +
      (it.img ? '<a href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(it.img) + '" alt="" width="56" height="56" loading="lazy"></a>' : "") +
      '<div class="gap-t">' + (it.gap ? "<small>Add this for free shipping</small>" : "") + '<b><a href="' + esc(it.url) + '">' + esc(it.title) + "</a></b><span>" + opt + money(it.price) + "</span></div>" +
      '<button type="button" class="btn gap-add" data-gap-add="' + it.variant + '" aria-label="Add ' + esc(it.title) + " for " + money(it.price) + '">Add</button></div>';
  }
  function row(items) {
    return '<div class="gap-row" data-gap-row><p class="gap-head">Add a small gift</p>' + items.map(card).join("") + "</div>";
  }

  var busy = false;
  function decorate(root) {
    if (busy || !root) return;
    var bar = root.querySelector(".ship-bar");
    if (!bar || root.querySelector("[data-gap-row]")) return;
    busy = true;
    fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (cart) {
      busy = false;
      var lines = (cart.items || []).filter(function (l) { return HANDLES.indexOf(l.handle) > -1; });
      var unitsC = lines.reduce(function (t, l) { return t + l.final_line_price; }, 0);
      var gapC = CAT.thresh ? CAT.thresh - unitsC : 0;
      if (!lines.length) return;
      var items = pick(gapC, lines.map(function (l) { return l.handle; }));
      var b = root.querySelector(".ship-bar");
      if (!items.length || !b || root.querySelector("[data-gap-row]")) return;
      b.insertAdjacentHTML("afterend", row(items));
    }).catch(function () { busy = false; });
  }

  function add(btn, onDone) {
    btn.disabled = true;
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.gapAdd), quantity: 1 }] }) })
      .then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { btn.disabled = false; if (window.__toast) window.__toast(e.description || "Could not add to cart."); });
        onDone();
      }).catch(function () { btn.disabled = false; });
  }

  function watch(root, onDone) {
    if (!root) return;
    new MutationObserver(function () { decorate(root); }).observe(root, { childList: true });
    root.addEventListener("click", function (e) { var b = e.target.closest("[data-gap-add]"); if (b) add(b, onDone); });
    decorate(root);
  }

  function init() {
    /* Drawer: store.js redraws #drawer-body on every change; after an add the header cart button redraws it again. */
    watch(document.getElementById("drawer-body"), function () { var o = document.getElementById("cart-open"); if (o) o.click(); });
    /* Cart page: the bar is drawn into #cart-ship; the page is server-rendered, so it reloads after an add. */
    watch(document.getElementById("cart-ship"), function () { location.reload(); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
